import { useState, useEffect, useMemo, useCallback, useRef } from "react";
import {
  AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer,
  CartesianGrid, ReferenceLine,
} from "recharts";
//import LogoRR_MAGMA from "../assets/logos/LOGO RR MAGMA.svg";
import { ReactComponent as LogoRR_MAGMA } from "../assets/logos/LOGO RR MAGMA.svg";

// ─── TYPOGRAPHY ──────────────────────────────────────────────
const FONT_IMPORT = `
@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:ital,wght@0,400;0,600;0,700;1,400&family=Fraunces:ital,wght@0,600;0,700;1,600&display=swap');
`;

// ─── PALETTE ─────────────────────────────────────────────────
const C = {
  bg:      "#07070a",
  surf:    "#0d0d14",
  card:    "#111118",
  border:  "#1e1e2a",
  gold:    "#c9a227",
  red:     "#f03e3e",
  imp:     "#ff6b6b",
  exp:     "#00d4a0",
  saldo:   "#6660fe",
  green:   "#34d399",
  blue:    "#60a5fa",
  amber:   "#fbbf24",
  purple:  "#c084fc",
  cyan:    "#22d3ee",
  orange:  "#fb923c",
  white:   "#e8e8f0",
  dim:     "rgba(232,232,240,0.75)",
  dimmer:  "rgba(232,232,240,0.60)",
};

// ─── API ─────────────────────────────────────────────────────
const GENOMA_API = "";

// ─── SECTOR IMAGES ───────────────────────────────────────────
const SECTOR_IMAGES = {
  pharma_chemicals: "https://images.unsplash.com/photo-1587854692152-cbe660dbde88?w=800&h=400&fit=crop&q=80",
  health:           "https://images.unsplash.com/photo-1584982751601-97dcc096659c?w=800&h=400&fit=crop&q=80",
  agro:             "https://images.unsplash.com/photo-1500937386664-56d1dfef3854?w=800&h=400&fit=crop&q=80",
  energy:           "https://images.unsplash.com/photo-1548337138-e87d889cc369?w=800&h=400&fit=crop&q=80",
  tech:             "https://images.unsplash.com/photo-1518770660439-4636190af475?w=800&h=400&fit=crop&q=80",
  batteries:        "https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=800&h=400&fit=crop&q=80",
  cosmetics:        "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=800&h=400&fit=crop&q=80",
  food:             "https://images.unsplash.com/photo-1498837167922-ddd27525d352?w=800&h=400&fit=crop&q=80",
  vehicles:         "https://images.unsplash.com/photo-1553440569-bcc63803a83d?w=800&h=400&fit=crop&q=80",
  materials:        "https://images.unsplash.com/photo-1533630359-fefad2c9c1c1?w=800&h=400&fit=crop&q=80",
  manufacturing:    "https://images.unsplash.com/photo-1565939988096-ba43b04a9f1b?w=800&h=400&fit=crop&q=80",
  netzero:          "https://images.unsplash.com/photo-1466611653911-95081537e5b7?w=800&h=400&fit=crop&q=80",
  air_defense:      "https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?w=800&h=400&fit=crop&q=80",
  audiovisual:      "https://images.unsplash.com/photo-1478720568477-152d9b164e26?w=800&h=400&fit=crop&q=80",
  corporate:        "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&h=400&fit=crop&q=80",
  luxury:           "https://images.unsplash.com/photo-1584917865442-de89df76afd3?w=800&h=400&fit=crop&q=80",
  mining_ops:       "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=800&h=400&fit=crop&q=80",
  moda_roupas:      "https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=800&h=400&fit=crop&q=80",
  organico_sustentavel: "https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?w=800&h=400&fit=crop&q=80",
  pets:             "https://images.unsplash.com/photo-1450778869180-41d0601e046e?w=800&h=400&fit=crop&q=80",
  sinteticos_inorganicos: "https://images.unsplash.com/photo-1567427017947-545c5f8d16ad?w=800&h=400&fit=crop&q=80",
  verao:            "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=800&h=400&fit=crop&q=80",
  drugs_apprehension: "https://images.unsplash.com/photo-1568992688065-536aad8a12f6?w=800&h=400&fit=crop&q=80",
  braskem_commodities: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=800&h=400&fit=crop&q=80",
  vale_commodities:  "https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=800&h=400&fit=crop&q=80",
  lojas_americanas_commodities: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=800&h=400&fit=crop&q=80",
  consumo:           "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=800&h=400&fit=crop&q=80",
  industria_quimica: "https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?w=800&h=400&fit=crop&q=80",
  imobiliario:       "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&h=400&fit=crop&q=80",
  fauna:             "https://images.unsplash.com/photo-1474511320723-9a56873867b5?w=800&h=400&fit=crop&q=80",
  gym:               "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&h=400&fit=crop&q=80",
};

const SECTOR_LABELS = {
  pharma_chemicals: "Química Farmacêutica", health: "Saúde",
  agro: "Agronegócio", energy: "Energia", tech: "Tecnologia",
  batteries: "Baterias", cosmetics: "Cosméticos", food: "Alimentos",
  vehicles: "Veículos", materials: "Materiais", manufacturing: "Manufatura",
  netzero: "Net Zero", air_defense: "Defesa", audiovisual: "Audiovisual",
  corporate: "Corporativo", luxury: "Luxo", mining_ops: "Mineração",
  moda_roupas: "Moda", organico_sustentavel: "Orgânico", pets: "Pets",
  sinteticos_inorganicos: "Sintéticos", verao: "Verão & Clima",
  drugs_apprehension: "Narcóticos", braskem_commodities: "Braskem",
  vale_commodities: "Vale", lojas_americanas_commodities: "Varejo",
  consumo: "Consumo", industria_quimica: "Química Industrial",
  imobiliario: "Imobiliário", fauna: "Fauna", gym: "Saúde & Esporte",
};

const SECTOR_COLORS = {
  pharma_chemicals: C.blue, health: C.blue, agro: C.green, energy: C.orange,
  tech: C.cyan, batteries: C.purple, cosmetics: "#f472b6", food: C.green,
  vehicles: C.amber, materials: "#a3a3a3", manufacturing: "#94a3b8",
  netzero: C.green, air_defense: C.red, audiovisual: C.purple,
  corporate: C.gold, luxury: C.gold, mining_ops: "#78716c",
  moda_roupas: "#f472b6", organico_sustentavel: C.green, pets: "#fb923c",
  sinteticos_inorganicos: C.purple, verao: C.amber, drugs_apprehension: C.red,
  braskem_commodities: C.purple, vale_commodities: "#78716c",
  lojas_americanas_commodities: C.amber, consumo: "#f472b6",
  industria_quimica: C.purple, imobiliario: "#a3a3a3", fauna: C.green,
  gym: C.cyan,
};

function sectorImage(sector) {
  return SECTOR_IMAGES[sector] ||
    "https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=800&h=400&fit=crop&q=80";
}

// ─── ROTATION MEMORY ─────────────────────────────────────────
const SEEN_KEY = "rr_genoma_explorer_seen_v1";
const SEEN_MAX = 15;

function getSeen() {
  try { return JSON.parse(sessionStorage.getItem(SEEN_KEY)) || []; }
  catch { return []; }
}
function pushSeen(id) {
  const cur = getSeen();
  const merged = [id, ...cur.filter(x => x !== id)].slice(0, SEEN_MAX);
  sessionStorage.setItem(SEEN_KEY, JSON.stringify(merged));
}

// ─── FORMATTING ──────────────────────────────────────────────
function formatFOB(v) {
  if (v == null || isNaN(v)) return "—";
  const abs = Math.abs(v);
  const sign = v < 0 ? "-" : "";
  if (abs >= 1e9) return `${sign}US$ ${(abs / 1e9).toFixed(2)}B`;
  if (abs >= 1e6) return `${sign}US$ ${(abs / 1e6).toFixed(2)}M`;
  if (abs >= 1e3) return `${sign}US$ ${(abs / 1e3).toFixed(0)}K`;
  return `${sign}US$ ${abs.toFixed(0)}`;
}

function tickFOB(v) {
  if (v == null) return "";
  const abs = Math.abs(v);
  if (abs >= 1e9) return `${v < 0 ? "-" : ""}$${(abs / 1e9).toFixed(1)}B`;
  if (abs >= 1e6) return `${v < 0 ? "-" : ""}$${(abs / 1e6).toFixed(0)}M`;
  if (abs >= 1e3) return `${v < 0 ? "-" : ""}$${(abs / 1e3).toFixed(0)}K`;
  return `${v < 0 ? "-" : ""}$${abs.toFixed(0)}`;
}

function shortMonth(monthStr) {
  if (!monthStr) return "";
  const [y, m] = monthStr.split("-");
  const months = ["jan","fev","mar","abr","mai","jun","jul","ago","set","out","nov","dez"];
  return `${months[parseInt(m) - 1]}/${y.slice(2)}`;
}

// ─── FETCHERS ────────────────────────────────────────────────
async function fetchAllClusters() {
  const res = await fetch(`${GENOMA_API}/api/genoma/clusters`);
  if (!res.ok) throw new Error(`clusters ${res.status}`);
  const data = await res.json();
  // API returns { total, clusters: [...] }
  return data.clusters || [];
}

async function fetchFeatured(n) {
  const res = await fetch(`${GENOMA_API}/api/genoma/featured?n=${n}&_=${Date.now()}`);
  if (!res.ok) throw new Error(`featured ${res.status}`);
  const data = await res.json();
  return data.featured || [];
}

async function fetchCluster(id) {
  const res = await fetch(`${GENOMA_API}/api/genoma/cluster/${id}`);
  if (!res.ok) throw new Error(`cluster ${res.status}`);
  return res.json();
}

async function fetchAnalytics(id) {
  const res = await fetch(`${GENOMA_API}/api/genoma/cluster/${id}/analytics`);
  if (!res.ok) throw new Error(`analytics ${res.status}`);
  return res.json();
}

async function fetchNCMSeries(ncm) {
  const res = await fetch(`${GENOMA_API}/api/genoma/ncm/${ncm}/series?flow=import`);
  if (!res.ok) return null;
  return res.json();
}

// ─── CUSTOM TOOLTIP ──────────────────────────────────────────
const ChartTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div style={{
      background: "rgba(7,7,10,0.96)",
      border: "1px solid #2a2a38",
      borderRadius: 6,
      padding: "10px 12px",
      fontFamily: "'IBM Plex Mono', monospace",
      minWidth: 160,
    }}>
      <div style={{ fontSize: 9, color: "rgba(232,232,240,0.4)", marginBottom: 6 }}>
        {shortMonth(label)}
      </div>
      {payload.map((p, i) => (
        <div key={i} style={{
          display: "flex", justifyContent: "space-between",
          alignItems: "center", gap: 12, padding: "3px 0",
        }}>
          <span style={{ fontSize: 10, color: p.color, fontWeight: 700, letterSpacing: "0.05em" }}>{p.name}</span>
          <span style={{ fontSize: 11, color: C.white, fontWeight: 700 }}>{formatFOB(p.value)}</span>
        </div>
      ))}
    </div>
  );
};

// ─── NCM ROW ─────────────────────────────────────────────────
function NCMRow({ ncm, active, onClick, subseries }) {
  const latest12 = subseries?.slice(-12) || [];
  const total12  = latest12.reduce((s, p) => s + (p.fob_usd || 0), 0);
  const prev12   = subseries?.slice(-24, -12) || [];
  const totalPrev = prev12.reduce((s, p) => s + (p.fob_usd || 0), 0);
  const yoyPct = totalPrev > 0 ? ((total12 - totalPrev) / totalPrev) * 100 : null;

  return (
    <button
      onClick={onClick}
      className="rr-genoma-ncm-row"
      style={{
        display: "flex", width: "100%", cursor: "pointer",
        background: active ? "rgba(102,96,254,0.06)" : "transparent",
        border: active ? "1px solid rgba(102,96,254,0.3)" : "1px solid transparent",
        borderBottom: active ? "1px solid rgba(102,96,254,0.3)" : "1px solid #1e1e2a",
        padding: "12px 14px",
        textAlign: "left", fontFamily: "inherit",
        transition: "all 0.15s",
        alignItems: "center", gap: 12,
      }}
    >
      <div style={{ flex: "0 0 78px" }}>
        <div style={{
          fontFamily: "'IBM Plex Mono', monospace",
          fontSize: 10, fontWeight: 700,
          color: active ? "#a5a2ff" : C.dim,
          letterSpacing: "0.02em",
        }}>{ncm.ncm}</div>
      </div>
      <div style={{ flex: "1 1 auto", minWidth: 0 }}>
        <div style={{
          fontFamily: "'Fraunces', Georgia, serif",
          fontSize: 12, color: C.white,
          lineHeight: 1.35, letterSpacing: "-0.005em",
          overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
        }}>{ncm.descricao}</div>
      </div>
      <div style={{ flex: "0 0 80px", textAlign: "right" }}>
        <div style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: 11, fontWeight: 700, color: C.white }}>
          {formatFOB(total12)}
        </div>
        {yoyPct != null && (
          <div style={{
            fontFamily: "'IBM Plex Mono', monospace", fontSize: 9, fontWeight: 700,
            color: yoyPct >= 0 ? C.exp : C.imp,
          }}>{yoyPct >= 0 ? "▲" : "▼"} {Math.abs(yoyPct).toFixed(1)}%</div>
        )}
      </div>
    </button>
  );
}

// ─── SEARCH BAR ──────────────────────────────────────────────
function ClusterSearch({ allClusters, onSelect }) {
  const [query, setQuery] = useState("");
  const [open, setOpen]   = useState(false);
  const inputRef          = useRef(null);
  const dropdownRef       = useRef(null);

  const filtered = useMemo(() => {
    if (!query.trim()) return [];
    const q = query.toLowerCase();
    return allClusters
      .filter(c => c.label.toLowerCase().includes(q))
      .slice(0, 12); // cap dropdown height
  }, [query, allClusters]);

  // Close on outside click
  useEffect(() => {
    function handler(e) {
      if (
        dropdownRef.current && !dropdownRef.current.contains(e.target) &&
        inputRef.current && !inputRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  function handleSelect(cluster) {
    setQuery(cluster.label);
    setOpen(false);
    onSelect(cluster.id);
    inputRef.current?.blur();
  }

  function handleClear() {
    setQuery("");
    setOpen(false);
    onSelect(null); // null = back to random
    inputRef.current?.focus();
  }

  const showDropdown = open && filtered.length > 0;

  return (
    <div style={{ position: "relative", flex: "1 1 auto", minWidth: 0 }}>
      <div style={{
        display: "flex", alignItems: "center",
        background: "rgba(255,255,255,0.03)",
        border: open ? "1px solid rgba(102,96,254,0.45)" : "1px solid #1e1e2a",
        borderRadius: 5,
        transition: "border-color 0.15s",
        overflow: "hidden",
      }}>
        {/* Search icon */}
        <span style={{
          padding: "0 10px 0 12px",
          fontSize: 12,
          color: open ? "rgba(102,96,254,0.8)" : C.dimmer,
          flexShrink: 0,
          transition: "color 0.15s",
          userSelect: "none",
        }}>⌕</span>

        <input
          ref={inputRef}
          type="text"
          placeholder="Buscar cluster..."
          value={query}
          onChange={e => { setQuery(e.target.value); setOpen(true); }}
          onFocus={() => { if (query) setOpen(true); }}
          style={{
            flex: 1,
            background: "transparent",
            border: "none",
            outline: "none",
            fontFamily: "'IBM Plex Mono', monospace",
            fontSize: 10,
            color: C.white,
            padding: "9px 0",
            letterSpacing: "0.04em",
            // placeholder color via CSS below
          }}
        />

        {/* Clear button — only when something is typed */}
        {query && (
          <button
            onClick={handleClear}
            style={{
              background: "transparent",
              border: "none",
              cursor: "pointer",
              color: C.dimmer,
              fontSize: 13,
              padding: "0 12px",
              fontFamily: "inherit",
              lineHeight: 1,
              flexShrink: 0,
            }}
            title="Limpar"
          >×</button>
        )}
      </div>

      {/* Dropdown */}
      {showDropdown && (
        <div
          ref={dropdownRef}
          style={{
            position: "absolute",
            top: "calc(100% + 4px)",
            left: 0, right: 0,
            background: "#0d0d14",
            border: "1px solid rgba(102,96,254,0.3)",
            borderRadius: 5,
            zIndex: 100,
            overflow: "hidden",
            boxShadow: "0 8px 32px rgba(0,0,0,0.6)",
          }}
        >
          {filtered.map((c, i) => (
            <button
              key={c.id}
              onMouseDown={() => handleSelect(c)} // mousedown to fire before blur
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                width: "100%",
                background: "transparent",
                border: "none",
                borderBottom: i < filtered.length - 1 ? "1px solid #1e1e2a" : "none",
                cursor: "pointer",
                padding: "10px 14px",
                textAlign: "left",
                fontFamily: "inherit",
                transition: "background 0.1s",
              }}
              onMouseEnter={e => e.currentTarget.style.background = "rgba(102,96,254,0.08)"}
              onMouseLeave={e => e.currentTarget.style.background = "transparent"}
            >
              {/* Sector color dot */}
              <span style={{
                width: 6, height: 6,
                borderRadius: "50%",
                background: SECTOR_COLORS[c.sector] || C.saldo,
                flexShrink: 0,
              }} />

              <span style={{
                fontFamily: "'Fraunces', Georgia, serif",
                fontSize: 12, color: C.white,
                flex: 1, minWidth: 0,
                overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
              }}>{c.label}</span>

              <span style={{
                fontFamily: "'IBM Plex Mono', monospace",
                fontSize: 8, color: C.dimmer,
                letterSpacing: "0.1em",
                flexShrink: 0,
              }}>{c.ncm_count} NCMs</span>
            </button>
          ))}

          {/* hint footer */}
          <div style={{
            padding: "6px 14px",
            fontSize: 8,
            color: "rgba(232,232,240,0.2)",
            letterSpacing: "0.1em",
            fontFamily: "'IBM Plex Mono', monospace",
            borderTop: "1px solid #1e1e2a",
          }}>
            {allClusters.length} CLUSTERS DISPONÍVEIS
          </div>
        </div>
      )}
    </div>
  );
}

// ─── MAIN ────────────────────────────────────────────────────
export default function GenomaTradeExplorer({
  theme = { cardBg: C.card, border: C.border },
}) {
  // ── Index of all clusters (fetched once for search) ──
  const [allClusters, setAllClusters] = useState([]);

  // ── Pinned cluster ID: set when user picks from search; null = random mode ──
  const [pinnedId, setPinnedId]       = useState(null);

  const [cluster, setCluster]         = useState(null);
  const [analytics, setAnalytics]     = useState(null);
  const [ncmSeries, setNcmSeries]     = useState({});
  const [activeNcm, setActiveNcm]     = useState(null);
  const [flow, setFlow]               = useState("balance");
  const [range, setRange]             = useState("12mo");
  const [loading, setLoading]         = useState(true);
  const [error, setError]             = useState(null);
  const [reloadTick, setReloadTick]   = useState(0);

  // ── Fetch flat cluster index once on mount ──
  useEffect(() => {
    fetchAllClusters()
      .then(setAllClusters)
      .catch(() => {}); // non-fatal; search just won't work
  }, []);

  // ── Main cluster load: random OR pinned ──
  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    setNcmSeries({});
    setActiveNcm(null);

    (async () => {
      try {
        let targetId;

        if (pinnedId) {
          // User selected from search — load directly
          targetId = pinnedId;
        } else {
          // Random mode
          const seen = getSeen();
          let feat = await fetchFeatured(6);
          feat = feat.filter(c => !seen.includes(c.id));
          if (feat.length === 0) feat = await fetchFeatured(3);
          const pick = feat.find(f => (f.ncm_count || 0) >= 5) || feat[0];
          if (!pick) throw new Error("Nenhum cluster disponível");
          targetId = pick.id;
        }

        pushSeen(targetId);

        const [clusterData, analyticsData] = await Promise.all([
          fetchCluster(targetId),
          fetchAnalytics(targetId).catch(() => ({ available: false })),
        ]);
        if (cancelled) return;

        setCluster(clusterData);
        setAnalytics(analyticsData?.available ? analyticsData : null);
        setActiveNcm(clusterData.ncms?.[0]?.ncm || null);
        setLoading(false);
      } catch (e) {
        if (!cancelled) {
          setError(e.message || "erro");
          setLoading(false);
        }
      }
    })();

    return () => { cancelled = true; };
  }, [reloadTick, pinnedId]);

  // ── Lazy NCM series fetch ──
  useEffect(() => {
    if (!activeNcm || ncmSeries[activeNcm]) return;
    let cancelled = false;
    fetchNCMSeries(activeNcm).then(data => {
      if (cancelled || !data) return;
      setNcmSeries(prev => ({ ...prev, [activeNcm]: data.series || [] }));
    });
    return () => { cancelled = true; };
  }, [activeNcm]); // eslint-disable-line react-hooks/exhaustive-deps

  // SORTEAR: clear pin and increment tick to force random reload
  const reroll = useCallback(() => {
    setPinnedId(null);
    setReloadTick(t => t + 1);
  }, []);

  // Search select: set pin (triggers main effect via pinnedId change)
  const handleSearchSelect = useCallback((id) => {
    if (id === null) {
      // User cleared search — go back to random
      reroll();
    } else {
      setPinnedId(id);
    }
  }, [reroll]);

  // ── Chart data ──
  const chartData = useMemo(() => {
    if (!analytics?.series) return [];
    const imp   = analytics.series.imports || [];
    const exp   = analytics.series.exports || [];
    const saldo = analytics.series.saldo   || [];
    const byMonth = {};
    imp.forEach(p => { byMonth[p.month] = { month: p.month, imports: p.fob_usd }; });
    exp.forEach(p => { byMonth[p.month] = { ...(byMonth[p.month] || { month: p.month }), exports: p.fob_usd }; });
    saldo.forEach(p => { byMonth[p.month] = { ...(byMonth[p.month] || { month: p.month }), saldo: p.value }; });
    let arr = Object.values(byMonth).sort((a, b) => a.month.localeCompare(b.month));
    if (range === "12mo") arr = arr.slice(-12);
    if (range === "5yr")  arr = arr.slice(-60);
    return arr;
  }, [analytics, range]);

  const stats    = analytics?.stats;
  const impStats = stats?.imports;
  const expStats = stats?.exports;
  const balStats = stats?.balance;

  const activeNcmSeries = activeNcm ? ncmSeries[activeNcm] : null;
  const activeNcmChart = useMemo(() => {
    if (!activeNcmSeries) return [];
    let arr = activeNcmSeries.map(p => ({ month: p.month, val: p.fob_usd }));
    if (range === "12mo") arr = arr.slice(-12);
    if (range === "5yr")  arr = arr.slice(-60);
    return arr;
  }, [activeNcmSeries, range]);

  const activeNcmInfo = cluster?.ncms?.find(n => n.ncm === activeNcm);
  const accent    = cluster ? (SECTOR_COLORS[cluster.sector] || C.blue) : C.blue;
  const sectorLbl = cluster ? (SECTOR_LABELS[cluster.sector] || cluster.sector) : "";

  return (
    <>
      <style>{FONT_IMPORT}{`
        * { box-sizing: border-box; }
        ::-webkit-scrollbar { width: 6px; height: 6px; }
        ::-webkit-scrollbar-thumb { background: #2a2a38; border-radius: 3px; }
        @keyframes rr-genoma-spin { to { transform: rotate(360deg); } }
        @keyframes rr-genoma-fade {
          from { opacity: 0; transform: translateY(4px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .rr-genoma-fade { animation: rr-genoma-fade 0.3s ease-out; }
        .rr-genoma-ncm-row:hover { background: rgba(255,255,255,0.02) !important; }
        .rr-genoma-reroll:hover {
          background: rgba(102,96,254,0.15) !important;
          border-color: rgba(102,96,254,0.5) !important;
        }
        .rr-genoma-reroll:active { transform: scale(0.97); }
        .rr-genoma-pill:hover { background: rgba(255,255,255,0.05) !important; }
        .rr-genoma-search-input::placeholder { color: rgba(232,232,240,0.25); }
        @media (max-width: 1100px) {
          .rr-genoma-explore-split { grid-template-columns: 1fr !important; }
          .rr-genoma-stats-row { grid-template-columns: repeat(3, 1fr) !important; }
        }
        @media (max-width: 700px) {
          .rr-genoma-stats-row { grid-template-columns: 1fr !important; }
          .rr-genoma-toolbar { flex-direction: column !important; }
        }
      `}</style>

      <div style={{
        background: theme.cardBg,
        borderRadius: 16,
        padding: 0,
        border: `1px solid ${theme.border}`,
        fontFamily: "'IBM Plex Mono', monospace",
        color: C.white,
        overflow: "hidden",
        width: "100%",
      }}>

        {/* ── TOOLBAR: search + sortear ── */}
        <div
          className="rr-genoma-toolbar"
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            padding: "12px 16px",
            borderBottom: "1px solid #1e1e2a",
            background: C.surf,
          }}
        >
          <ClusterSearch allClusters={allClusters} onSelect={handleSearchSelect} />

          <button
            className="rr-genoma-reroll"
            onClick={reroll}
            style={{
              flexShrink: 0,
              background: "rgba(255,255,255,0.04)",
              border: "1px solid #1e1e2a",
              borderRadius: 5,
              color: C.dimmer,
              fontSize: 9, fontWeight: 700,
              padding: "9px 14px",
              cursor: "pointer",
              fontFamily: "inherit",
              letterSpacing: "0.12em",
              display: "flex", alignItems: "center", gap: 6,
              transition: "all 0.15s",
              whiteSpace: "nowrap",
            }}
          >
            <span>↻</span> SORTEAR
          </button>
        </div>

        {/* ── CLUSTER BODY ── */}
        {loading ? (
          <div style={{ padding: "80px 20px", textAlign: "center", color: C.dimmer, fontSize: 11 }}>
            <div style={{ display: "inline-block", animation: "rr-genoma-spin 1s linear infinite" }}>↻</div>
            &nbsp; {pinnedId ? "Carregando cluster..." : "Sorteando cluster..."}
          </div>
        ) : error ? (
          <div style={{ padding: 40, textAlign: "center", color: C.red, fontSize: 12 }}>{error}</div>
        ) : cluster && (
          <div className="rr-genoma-fade" key={cluster.id}>

            {/* Hero image band */}
            <div style={{
              position: "relative", height: 200, overflow: "hidden",
              background: `url(${sectorImage(cluster.sector)}) center/cover`,
            }}>
              <div style={{
                position: "absolute", inset: 0,
                background: "linear-gradient(180deg, rgba(7,7,10,0.5) 0%, rgba(7,7,10,0.35) 40%, rgba(7,7,10,0.98) 100%)",
              }} />

              {/* Logo + product tag */}
              <div style={{
                position: "absolute", top: 18, left: 22,
                display: "flex", alignItems: "center", gap: 12,
              }}>
                <LogoRR_MAGMA style={{ width: 86, height: "auto", display: "block" }} />
                <span style={{
                  fontSize: 9, fontWeight: 700, color: C.gold,
                  background: "rgba(201,162,39,0.12)",
                  border: "1px solid rgba(201,162,39,0.3)",
                  padding: "3px 8px", borderRadius: 3,
                  letterSpacing: "0.14em",
                }}>GENOMA · TRADE EXPLORER</span>
              </div>

              {/* Pinned badge */}
              {pinnedId && (
                <div style={{
                  position: "absolute", top: 18, right: 22,
                  background: "rgba(102,96,254,0.15)",
                  border: "1px solid rgba(102,96,254,0.4)",
                  borderRadius: 4,
                  padding: "4px 10px",
                  fontSize: 8, fontWeight: 700,
                  color: "#a5a2ff",
                  letterSpacing: "0.12em",
                }}>◆ SELECIONADO</div>
              )}

              {/* Title */}
              <div style={{ position: "absolute", bottom: 18, left: 22, right: 22 }}>
                <div style={{
                  fontSize: 9, fontWeight: 700, color: accent,
                  letterSpacing: "0.16em", marginBottom: 5,
                  textShadow: "0 2px 8px rgba(0,0,0,0.6)",
                }}>
                  {sectorLbl ? `${sectorLbl.toUpperCase()} · ` : ""}{cluster.ncm_count} NCMs
                </div>
                <h2 style={{
                  fontFamily: "'Fraunces', Georgia, serif",
                  fontSize: 32, fontWeight: 700,
                  color: C.white, margin: 0,
                  lineHeight: 1.05, letterSpacing: "-0.02em",
                  textShadow: "0 2px 12px rgba(0,0,0,0.7)",
                }}>{cluster.label}</h2>
              </div>
            </div>

            {/* Stats strip */}
            {stats && (
              <div className="rr-genoma-stats-row" style={{
                display: "grid", gridTemplateColumns: "repeat(3, 1fr)",
                gap: 1, background: "#1e1e2a", borderBottom: "1px solid #1e1e2a",
              }}>
                <div style={{ padding: "16px 22px", background: C.card }}>
                  <div style={{ fontSize: 8, fontWeight: 700, color: C.imp, letterSpacing: "0.16em", marginBottom: 8 }}>IMPORTAÇÕES · 12mo</div>
                  <div style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: 20, fontWeight: 700, color: C.white, lineHeight: 1 }}>{formatFOB(impStats?.total_fob_12mo)}</div>
                  {impStats?.yoy_pct != null && (
                    <div style={{ fontSize: 10, fontWeight: 700, marginTop: 6, color: impStats.yoy_pct >= 0 ? C.exp : C.imp }}>
                      {impStats.yoy_pct >= 0 ? "▲" : "▼"} {Math.abs(impStats.yoy_pct).toFixed(1)}% YoY
                    </div>
                  )}
                </div>
                <div style={{ padding: "16px 22px", background: C.card }}>
                  <div style={{ fontSize: 8, fontWeight: 700, color: C.exp, letterSpacing: "0.16em", marginBottom: 8 }}>EXPORTAÇÕES · 12mo</div>
                  <div style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: 20, fontWeight: 700, color: C.white, lineHeight: 1 }}>{formatFOB(expStats?.total_fob_12mo)}</div>
                  {expStats?.yoy_pct != null && (
                    <div style={{ fontSize: 10, fontWeight: 700, marginTop: 6, color: expStats.yoy_pct >= 0 ? C.exp : C.imp }}>
                      {expStats.yoy_pct >= 0 ? "▲" : "▼"} {Math.abs(expStats.yoy_pct).toFixed(1)}% YoY
                    </div>
                  )}
                </div>
                <div style={{ padding: "16px 22px", background: C.card }}>
                  <div style={{ fontSize: 8, fontWeight: 700, color: C.saldo, letterSpacing: "0.16em", marginBottom: 8 }}>SALDO · 12mo</div>
                  <div style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: 20, fontWeight: 700, color: C.white, lineHeight: 1 }}>{formatFOB(balStats?.saldo_12mo_total)}</div>
                  {balStats?.status && (
                    <div style={{
                      fontSize: 9, fontWeight: 700, marginTop: 6,
                      color: balStats.status === "superavit" ? C.exp : balStats.status === "deficit" ? C.imp : C.dimmer,
                      letterSpacing: "0.14em", textTransform: "uppercase",
                    }}>
                      {balStats.status === "superavit" ? "◆ Superávit" : balStats.status === "deficit" ? "◆ Déficit" : "◆ Neutro"}
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Controls */}
            <div style={{
              padding: "14px 22px",
              display: "flex", justifyContent: "space-between",
              alignItems: "center", gap: 12, flexWrap: "wrap",
              borderBottom: "1px solid #1e1e2a",
            }}>
              <div style={{ display: "flex", gap: 4 }}>
                {[
                  { key: "balance", label: "BALANÇA", color: C.saldo },
                  { key: "imports", label: "IMPORT",  color: C.imp },
                  { key: "exports", label: "EXPORT",  color: C.exp },
                ].map(f => {
                  const isActive = flow === f.key;
                  return (
                    <button key={f.key} onClick={() => setFlow(f.key)} className="rr-genoma-pill" style={{
                      padding: "6px 12px", borderRadius: 4, fontFamily: "inherit",
                      fontSize: 9, fontWeight: 700, letterSpacing: "0.14em", cursor: "pointer",
                      border: isActive ? `1px solid ${f.color}50` : "1px solid #1e1e2a",
                      background: isActive ? `${f.color}12` : "transparent",
                      color: isActive ? f.color : C.dimmer, transition: "all 0.15s",
                    }}>{f.label}</button>
                  );
                })}
              </div>
              <div style={{ display: "flex", gap: 4 }}>
                {[
                  { key: "12mo", label: "12M" },
                  { key: "5yr",  label: "5A" },
                  { key: "all",  label: "TUDO" },
                ].map(r => {
                  const isActive = range === r.key;
                  return (
                    <button key={r.key} onClick={() => setRange(r.key)} className="rr-genoma-pill" style={{
                      padding: "6px 12px", borderRadius: 4, fontFamily: "inherit",
                      fontSize: 9, fontWeight: 700, letterSpacing: "0.12em", cursor: "pointer",
                      border: isActive ? "1px solid rgba(255,255,255,0.2)" : "1px solid #1e1e2a",
                      background: isActive ? "rgba(255,255,255,0.04)" : "transparent",
                      color: isActive ? C.white : C.dimmer, transition: "all 0.15s",
                    }}>{r.label}</button>
                  );
                })}
              </div>
            </div>

            {/* Main chart */}
            <div style={{ padding: "16px 8px 20px", borderBottom: "1px solid #1e1e2a" }}>
              {chartData.length > 0 ? (
                <ResponsiveContainer width="100%" height={280}>
                  <AreaChart data={chartData} margin={{ top: 12, right: 28, left: 12, bottom: 4 }}>
                    <defs>
                      <linearGradient id="grad-imp"   x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%"   stopColor={C.imp}   stopOpacity={0.35} />
                        <stop offset="100%" stopColor={C.imp}   stopOpacity={0} />
                      </linearGradient>
                      <linearGradient id="grad-exp"   x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%"   stopColor={C.exp}   stopOpacity={0.35} />
                        <stop offset="100%" stopColor={C.exp}   stopOpacity={0} />
                      </linearGradient>
                      <linearGradient id="grad-saldo" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%"   stopColor={C.saldo} stopOpacity={0.35} />
                        <stop offset="100%" stopColor={C.saldo} stopOpacity={0} />
                      </linearGradient>
                    </defs>
                    <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.03)" vertical={false} />
                    <XAxis dataKey="month" stroke="#333" fontSize={8}
                      tickLine={false} axisLine={false} tickFormatter={shortMonth}
                      interval={range === "all" ? Math.floor(chartData.length / 8) : range === "5yr" ? 5 : 0}
                      tick={{ fill: "rgba(232,232,240,0.35)", fontFamily: "'IBM Plex Mono', monospace" }} />
                    <YAxis stroke="#333" fontSize={8} tickLine={false} axisLine={false}
                      tickFormatter={tickFOB} width={54}
                      tick={{ fill: "rgba(232,232,240,0.35)", fontFamily: "'IBM Plex Mono', monospace" }} />
                    <ReferenceLine y={0} stroke="rgba(255,255,255,0.15)" strokeWidth={1} />
                    <Tooltip content={<ChartTooltip />} />
                    {(flow === "balance" || flow === "imports") && (
                      <Area type="monotone" dataKey="imports" name="Import"
                        stroke={C.imp} strokeWidth={2} fill="url(#grad-imp)" dot={false} />
                    )}
                    {(flow === "balance" || flow === "exports") && (
                      <Area type="monotone" dataKey="exports" name="Export"
                        stroke={C.exp} strokeWidth={2} fill="url(#grad-exp)" dot={false} />
                    )}
                    {flow === "balance" && (
                      <Area type="monotone" dataKey="saldo" name="Saldo"
                        stroke={C.saldo} strokeWidth={2} fill="url(#grad-saldo)" dot={false} strokeDasharray="4 3" />
                    )}
                  </AreaChart>
                </ResponsiveContainer>
              ) : (
                <div style={{ padding: "40px 20px", textAlign: "center", color: C.dimmer, fontSize: 11 }}>
                  Sem série temporal disponível.
                </div>
              )}
            </div>

            {/* NCM explorer */}
            <div className="rr-genoma-explore-split" style={{
              display: "grid", gridTemplateColumns: "minmax(0, 1.4fr) minmax(0, 1fr)",
              alignItems: "start", gap: 0, borderBottom: "1px solid #1e1e2a",
            }}>
              <div style={{ borderRight: "1px solid #1e1e2a", minWidth: 0 }}>
                <div style={{ padding: "12px 18px", borderBottom: "1px solid #1e1e2a", background: C.surf }}>
                  <div style={{ fontSize: 8, fontWeight: 700, color: accent, letterSpacing: "0.16em", marginBottom: 2 }}>
                    COMPOSIÇÃO DO CLUSTER
                  </div>
                  <div style={{ fontFamily: "'Fraunces', Georgia, serif", fontStyle: "italic", fontSize: 11, color: C.dim }}>
                    Clique em um NCM para ver a série individual
                  </div>
                </div>
                <div style={{ maxHeight: 420, overflow: "auto" }}>
                  {(cluster.ncms || []).slice(0, 40).map(n => (
                    <NCMRow key={n.ncm} ncm={n} active={activeNcm === n.ncm}
                      onClick={() => setActiveNcm(n.ncm)} subseries={ncmSeries[n.ncm]} />
                  ))}
                  {cluster.ncms?.length > 40 && (
                    <div style={{
                      padding: "12px 14px", textAlign: "center",
                      fontSize: 9, color: C.dimmer, letterSpacing: "0.1em",
                      borderTop: "1px solid #1e1e2a",
                    }}>
                      + {cluster.ncms.length - 40} NCMs adicionais neste cluster
                    </div>
                  )}
                </div>
              </div>

              <div style={{ padding: "16px 20px", minWidth: 0 }}>
                {activeNcmInfo ? (
                  <>
                    <div style={{ fontSize: 8, fontWeight: 700, color: accent, letterSpacing: "0.16em", marginBottom: 8 }}>
                      NCM {activeNcmInfo.ncm}
                    </div>
                    <div style={{
                      fontFamily: "'Fraunces', Georgia, serif",
                      fontSize: 18, fontWeight: 600, color: C.white,
                      lineHeight: 1.25, letterSpacing: "-0.01em", marginBottom: 10,
                    }}>{activeNcmInfo.descricao}</div>
                    {activeNcmInfo.comment && (
                      <div style={{
                        fontSize: 11, color: C.dim, lineHeight: 1.6, marginBottom: 16,
                        fontFamily: "'IBM Plex Mono', monospace", letterSpacing: "0.005em",
                      }}>{activeNcmInfo.comment}</div>
                    )}
                    <div style={{ fontSize: 8, fontWeight: 700, color: C.dimmer, letterSpacing: "0.14em", marginBottom: 8, marginTop: 12 }}>
                      SÉRIE INDIVIDUAL DESTE NCM · IMPORTAÇÕES
                    </div>
                    {activeNcmChart.length > 0 ? (
                      <ResponsiveContainer width="100%" height={140}>
                        <AreaChart data={activeNcmChart} margin={{ top: 4, right: 8, left: 0, bottom: 0 }}>
                          <defs>
                            <linearGradient id="grad-ncm" x1="0" y1="0" x2="0" y2="1">
                              <stop offset="0%"   stopColor={accent} stopOpacity={0.4} />
                              <stop offset="100%" stopColor={accent} stopOpacity={0} />
                            </linearGradient>
                          </defs>
                          <XAxis dataKey="month" fontSize={7} tickLine={false} axisLine={false}
                            tickFormatter={shortMonth}
                            interval={range === "all" ? Math.floor(activeNcmChart.length / 6) : range === "5yr" ? 8 : 1}
                            tick={{ fill: "rgba(232,232,240,0.3)", fontFamily: "'IBM Plex Mono', monospace" }} />
                          <YAxis fontSize={7} tickLine={false} axisLine={false} tickFormatter={tickFOB} width={44}
                            tick={{ fill: "rgba(232,232,240,0.3)", fontFamily: "'IBM Plex Mono', monospace" }} />
                          <Tooltip content={<ChartTooltip />} />
                          <Area type="monotone" dataKey="val" name="Import"
                            stroke={accent} strokeWidth={1.8} fill="url(#grad-ncm)" dot={false} />
                        </AreaChart>
                      </ResponsiveContainer>
                    ) : (
                      <div style={{ padding: "20px 12px", textAlign: "center", fontSize: 10, color: C.dimmer }}>
                        <span style={{ display: "inline-block", animation: "rr-genoma-spin 1s linear infinite" }}>↻</span>
                        {" "}Carregando série...
                      </div>
                    )}
                    <div style={{ fontSize: 8, color: C.dimmer, marginTop: 10, letterSpacing: "0.1em" }}>
                      UNIDADE · {activeNcmInfo.unidade || "—"}
                    </div>
                  </>
                ) : (
                  <div style={{ padding: 20, textAlign: "center", color: C.dimmer, fontSize: 11 }}>
                    Selecione um NCM na lista
                  </div>
                )}
              </div>
            </div>

            {/* Footer */}
            <div style={{ padding: "14px 22px 18px" }}>
              <div style={{
                padding: "7px 11px",
                background: "rgba(251,191,36,0.04)",
                border: "1px solid rgba(251,191,36,0.08)",
                borderRadius: 4, marginBottom: 12,
              }}>
                <p style={{ fontSize: 8, color: "rgba(251,191,36,0.5)", lineHeight: 1.4, margin: 0, fontFamily: "inherit" }}>
                  <strong style={{ color: "rgba(251,191,36,0.7)" }}>⚠ FONTE:</strong>{" "}
                  Siscomex/MDIC · agregados mensais · valores em US$ FOB.
                  Não constitui recomendação de investimento.
                </p>
              </div>
              <a
                href={`https://relatorioreservado.com.br/magma/genoma/${cluster.id}`}
                target="_blank" rel="noopener noreferrer"
                style={{
                  display: "block", width: "100%",
                  padding: "12px 0", textAlign: "center",
                  background: "#6660fe", border: "1px solid #6660fe",
                  borderRadius: 6, color: "#fff",
                  fontSize: 11, fontWeight: 700, letterSpacing: "0.14em",
                  textDecoration: "none",
                  fontFamily: "'IBM Plex Mono', monospace",
                  transition: "background 0.15s",
                }}
                onMouseEnter={e => e.currentTarget.style.background = "#7570ff"}
                onMouseLeave={e => e.currentTarget.style.background = "#6660fe"}
              >
                ▶ EXPLORAR CLUSTER COMPLETO
              </a>
            </div>
          </div>
        )}
      </div>
    </>
  );
}